import { FormikProps } from "formik";
import { Profile } from "src/molecules/ProfileForm/ProfileForm";
import type { Address, Checkout } from "src/types/forms";

export const clearAddressFields = (
  formik: FormikProps<Checkout> | FormikProps<Profile>,
  addressType: "shippingAddress" | "billingAddress"
): void => {
  const addressFields: Omit<
    Address & { isStreetNumberNotRequired: boolean },
    "country"
  > = {
    streetName: "",
    streetNumber: "",
    additionalStreetInfo: "",
    postalCode: "",
    city: "",
    state: "",
    isStreetNumberNotRequired: false,
  };

  Object.entries(addressFields).forEach(([key, value]) => {
    void formik.setFieldTouched(`${addressType}.${key}`, false);
    void formik.setFieldValue(`${addressType}.${key}`, value);
  });
};
